function areDatesSame(date1: Date | null, date2: Date | null): boolean {
  if (date1 === null && date2 === null) return true;
  if (date1 === null || date2 === null) return false;
  return date1.getTime() === date2.getTime();
}

export function haveDatesChanged(start1: Date | null, end1: Date | null, start2: Date | null, end2: Date | null): boolean {
  return !areDatesSame(start1, start2) || !areDatesSame(end1, end2);
}

// UAT 27.07 #4 : une fin avant le début est une erreur de saisie à afficher, jamais une fenêtre
// à charger, appliquer ou persister ; une fenêtre d'un seul jour reste valide.
export function isEndBeforeStart(start: Date | null, end: Date | null): boolean {
  return start !== null && end !== null && end.getTime() < start.getTime();
}
